import { version } from '../../package.json';
export default version;


//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/chenshuai/ant-design-pro-site/scaffold/node_modules/antd/es/version/index.js
// module id = 994
// module chunks = 0